import { MAX_CV_SIZE } from "../constants/jobOffer";
import {FILE_ERROR} from "../constants/variables";
import Utils from "@/mixins/Utils";

export default {
  mixin: [Utils],
  data() {
    return {
    };
  },
  methods: {
    uploadFile(event, checkType, maxSize) {
        // check size, size must be less than IMAGE_SIZE_LIMIT
        return new Promise((resolve, reject) => {
          if (event) {
            const fileSize = event.size / 1024 / 1024;
            if (fileSize > maxSize) {
              reject(FILE_ERROR.MAX_SIZE);
            }
            const reader = new FileReader();
            reader.readAsArrayBuffer(event);
            reader.onload = e => {
              const arr = new Uint8Array(e.target.result, 0, 4);
              let header = '';
              for (let i = 0; i < arr.length; i++) {
                header += arr[i].toString(16);
              }
              const type = this.checkFileType(header);
              if (checkType.includes(type)) {
                resolve(reader);
                return;
              }
              reject(FILE_ERROR.INVALID_MIME);
            };
            reader.onerror = error => {
              this.callToaster(error);
            }
          }
        })
    },
    checkFileType(header) {
      let type = '';
      switch (header) {
        case '89504e47':
          type = 'image/png';
          break;
        case '47494638':
          type = 'image/gif';
          break;
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
          type = 'image/jpeg';
          break;
        case '25504446':
          type = 'pdf';
          break;
        default:
          type = 'unknown'; // Or you can use the blob.type as fallback
          break;
      }
      return type;
    }
  },
};
